import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _cffe3db6 = () => interopDefault(import('~/pages/_.vue' /* webpackChunkName: "" */))
const _fe9de024 = () => interopDefault(import('../../../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about-eagle-strategies",
    component: _cffe3db6,
    name: "about-eagle-strategies"
  }, {
    path: "/about-new-york-life",
    component: _cffe3db6,
    name: "about-new-york-life"
  }, {
    path: "/about-us",
    component: _cffe3db6,
    name: "about-us"
  }, {
    path: "/copyright",
    component: _cffe3db6,
    name: "copyright"
  }, {
    path: "/gail-ann-kincannon",
    component: _cffe3db6,
    name: "gail-ann-kincannon"
  }, {
    path: "/get-in-touch",
    component: _cffe3db6,
    name: "get-in-touch"
  }, {
    path: "/kathryn-allen-watson",
    component: _cffe3db6,
    name: "kathryn-allen-watson"
  }, {
    path: "/our-expertise",
    component: _cffe3db6,
    name: "our-expertise"
  }, {
    path: "/resources",
    component: _cffe3db6,
    name: "resources"
  }, {
    path: "/samantha-k-rostek",
    component: _cffe3db6,
    name: "samantha-k-rostek"
  }, {
    path: "/sonali-amodwala",
    component: _cffe3db6,
    name: "sonali-amodwala"
  }, {
    path: "/victoria-briones-magallanez",
    component: _cffe3db6,
    name: "victoria-briones-magallanez"
  }, {
    path: "/business-solutions/executive-benefits",
    component: _cffe3db6,
    name: "executive-benefits"
  }, {
    path: "/business-solutions/funding-buy-sell-agreements",
    component: _cffe3db6,
    name: "funding-buy-sell-agreements"
  }, {
    path: "/business-solutions/funding-deferred-compensation",
    component: _cffe3db6,
    name: "funding-deferred-compensation"
  }, {
    path: "/business-solutions/key-person-insurance",
    component: _cffe3db6,
    name: "key-person-insurance"
  }, {
    path: "/business-solutions/succession-planning",
    component: _cffe3db6,
    name: "succession-planning"
  }, {
    path: "/employee-benefits/flexible-spending-accounts",
    component: _cffe3db6,
    name: "flexible-spending-accounts"
  }, {
    path: "/employee-benefits/group-dental-and-vision-plans",
    component: _cffe3db6,
    name: "group-dental-and-vision-plans"
  }, {
    path: "/employee-benefits/group-disability-insurance-plans",
    component: _cffe3db6,
    name: "group-disability-insurance-plans"
  }, {
    path: "/employee-benefits/group-life-insurance-plans",
    component: _cffe3db6,
    name: "group-life-insurance-plans"
  }, {
    path: "/employee-benefits/group-major-medical-plans",
    component: _cffe3db6,
    name: "group-major-medical-plans"
  }, {
    path: "/employee-benefits/retirement-plans",
    component: _cffe3db6,
    name: "retirement-plans"
  }, {
    path: "/employee-benefits/voluntary-coverage",
    component: _cffe3db6,
    name: "voluntary-coverage"
  }, {
    path: "/personal-solutions/401k-and-ira-rollovers",
    component: _cffe3db6,
    name: "401k-and-ira-rollovers"
  }, {
    path: "/personal-solutions/asset-protection",
    component: _cffe3db6,
    name: "asset-protection"
  }, {
    path: "/personal-solutions/charitable-planning",
    component: _cffe3db6,
    name: "charitable-planning"
  }, {
    path: "/personal-solutions/disability-and-extended-care-needs",
    component: _cffe3db6,
    name: "disability-and-extended-care-needs"
  }, {
    path: "/personal-solutions/estate-planning",
    component: _cffe3db6,
    name: "estate-planning"
  }, {
    path: "/personal-solutions/financial-planning",
    component: _cffe3db6,
    name: "financial-planning"
  }, {
    path: "/personal-solutions/special-needs-trust-planning",
    component: _cffe3db6,
    name: "special-needs-trust-planning"
  }, {
    path: "/personal-solutions/wealth-management",
    component: _cffe3db6,
    name: "wealth-management"
  }, {
    path: "/",
    component: _cffe3db6,
    name: "home"
  }, {
    path: "/*",
    component: _fe9de024,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
